import { useEffect, useState, useCallback } from 'react';
import ResourceCard from './ResourceCard';
import ResourceHalfSection from './ResourceHalfSection';
import { RootState, useAppDispatch, useAppSelector } from 'store';
import { getResources } from 'network/getResources';
import { IResourceCard } from 'interfaces/components/resources';
import { setResourcesArr } from 'store/chartsInfo/chartsInfo.slice';
import { mapTopInsights, mapForYouResources } from 'utils/helpers/mapResources';
import { useMediaQuery } from 'react-responsive';

const Resources = () => {
  const isMdScreen = useMediaQuery({ query: '(max-width: 943px)' });
  const isLgScreen = useMediaQuery({ query: '(max-width: 1232px)' });
  const dispatch = useAppDispatch();

  const currentARR = useAppSelector(
    (state: RootState) => state.companyInfo.requiredInfo.currentARR
  );

  const chartSwitches = useAppSelector(
    (state: RootState) => state.chartSwitches
  );

  const isSidebarOpen = useAppSelector(
    (state: RootState) => state.chartsInfo.isSidebarOpen
  );

  const isSmScreen = isSidebarOpen ? isLgScreen : isMdScreen;

  const chartsInfo = useAppSelector((state: RootState) => state.chartsInfo);
  const chartFilters = useAppSelector((state: RootState) => state.chartFilters);

  const [topInsights, setTopInsights] = useState<IResourceCard[]>([]);
  const [forYouResources, setForYouResources] = useState<IResourceCard[]>([]);

  const loadResources = useCallback(async () => {
    try {
      const data = await getResources();
      dispatch(setResourcesArr(data));
    } catch (error: any) {}
  }, [dispatch]);

  useEffect(() => {
    if (chartsInfo.resourcesArr.length === 0) {
      loadResources();
    }
  }, [loadResources, chartsInfo.resourcesArr]);

  useEffect(() => {
    setTopInsights(mapTopInsights(chartsInfo.resourcesArr));
  }, [chartsInfo.resourcesArr]);

  useEffect(() => {
    setForYouResources(
      mapForYouResources(
        chartsInfo.resourcesArr,
        currentARR,
        chartSwitches,
        chartsInfo
      )
    );
  }, [chartsInfo, chartSwitches, currentARR, chartFilters]);

  return (
    <div className='w-full mt-8' id='resources-section'>
      <span className='text-3xl font-semibold'>Resources</span>
      <div className='mt-6 flex justify-center gap-6'>
        {chartsInfo.resourcesArr.length === 0 ? (
          <div className='flex flex-col justify-center items-center'>
            <div className='h-16 w-16 animate-spin border-[6px] border-[#d7d6d5] border-t-green-400 rounded-full ' />
            <p className='mt-4'>Loading...</p>
          </div>
        ) : (
          <>
            <ResourceHalfSection title='For You'>
              {forYouResources.map(resource => (
                <ResourceCard
                  key={resource.url}
                  resource={resource}
                  isSmScreen={isSmScreen}
                />
              ))}
            </ResourceHalfSection>
            <ResourceHalfSection title='Top Insights This Month'>
              {topInsights.map(resource => (
                <ResourceCard
                  key={resource.url}
                  resource={resource}
                  isSmScreen={isSmScreen}
                />
              ))}
            </ResourceHalfSection>
          </>
        )}
      </div>
    </div>
  );
};

export default Resources;
